import { css } from '@emotion/react'

export const noWrap = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const normal = css`
  white-space: normal;
`
